import React from "react";
import "./footer.css";

export const Footer = () => {
  // Action on Click
  const helpDropDown = () => {
    document.querySelector(".fhelp .fa-plus").classList.toggle("active");
    const lis = document.querySelectorAll(".fhelp ul li");
    lis.forEach((li) => {
      li.classList.toggle("active");
    });
  };

  const productsDropDown = () => {
    document.querySelector(".fproducts .fa-plus").classList.toggle("active");
    const lis = document.querySelectorAll(".fproducts ul li");
    lis.forEach((li) => {
      li.classList.toggle("active");
    });
  };

  const companyDropDown = () => {
    document.querySelector(".fcompany .fa-plus").classList.toggle("active");
    const lis = document.querySelectorAll(".fcompany ul li");
    lis.forEach((li) => {
      li.classList.toggle("active");
    });
  };

  return (
    <div>
      <footer>
        <div className="footer">
          <div className="footerTop">
            <div className="footerContent">
              <div className="fhelp">
                <div>
                  <p className="footerHead" onClick={helpDropDown}>
                    Help<i className="fa fa-plus"></i>
                  </p>
                  <ul>
                    <li>
                      <a href="#">contact us</a>
                    </li>
                    <li>
                      <a href="#">FAQs</a>
                    </li>
                  </ul>
                </div>
                <div className="faddress">
                  <p className="addressHead">Registered Address</p>
                  <p>
                    Vinamara Kand Gomatinagar
                    <br />
                    Lucknow Utter Pradesh
                    <br />
                    India-226010
                  </p>
                </div>
              </div>

              <div className="fproducts">
                <p className="footerHead" onClick={productsDropDown}>
                  Products<i className="fa fa-plus"></i>
                </p>
                <ul>
                  <li>
                    <a href="#">Wallet</a>
                  </li>
                  <li>
                    <a href="#">Entwicklers</a>
                  </li>
                  <li>
                    <a href="#">EaseWedding</a>
                  </li>
                </ul>
              </div>

              <div className="fcompany">
                <p className="footerHead" onClick={companyDropDown}>
                  Company<i className="fa fa-plus"></i>
                </p>
                <ul>
                  <li>
                    <a href="#">about-the nu begining</a>
                  </li>
                  <li>
                    <a href="#">company news</a>
                  </li>
                  <li>
                    <a href="#">carrier oportunies</a>
                  </li>
                  <li>
                    <a href="#">investers</a>
                  </li>
                  <li>
                    <a href="#">team</a>
                  </li>
                  <li>
                    <a href="#">responsible disclosure</a>
                  </li>
                </ul>
              </div>
            </div>

            <div className="followUs">
              <p>Follow Us</p>
              <div className="socialIcon">
                <a href="#">
                  <i className="fab fa-facebook"></i>
                </a>
                <a href="#">
                  <i className="fab fa-twitter"></i>
                </a>
                <a href="#">
                  <i className="fab fa-instagram"></i>
                </a>
                <a href="#">
                  <i className="fab fa-linkedin"></i>
                </a>
              </div>
              <div className="imgAndAddress">
                <img src="logo.svg" alt="The Nu Beginnings" />
                <div className="faddressMobile">
                  <p className="addressHead">Registered Address</p>
                  <p>
                    Vinamara Kand Gomatinagar
                    <br />
                    Lucknow Utter Pradesh
                    <br />
                    India-226010
                  </p>
                </div>
              </div>
            </div>
          </div>
          <div className="footerBottom">
            <p> &copy;2021 NuBeginings india Pvt. Ltd. All rights reserved</p>
            <p className="privacy">
              <a href="#">Privacy Policy </a>|<a href="#"> Terms of Use </a>|
              <a href="#"> Legal </a>|<a href="#"> Site Map</a>
            </p>
          </div>
        </div>
      </footer>
    </div>
  );
};

